export default __webpack_public_path__ + "static/media/cell-spreader.8aa95f97.svg";